export const SummaryMessageState = {
  error: false,
  payload: [],
  messageUser: {},
  messageItem: '',
  itemData: {},
  message: '',
};
